import { useEffect, useState } from 'react';
import Constant from '@/common/constant/Constant';
import { MenuItem, Menu } from '@material-ui/core';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';
import Utils from '@/common/utils/utils';
import { cloneDeep } from 'lodash';

function ListTagFieldDropDown(props) {
    const [anchorEl, setAnchorEl] = useState(null);

    useEffect(() => {
        if (
            !Utils.isEmptyObject(props?.selectedTagField) &&
            !Utils.isEmptyArray(props.listTagFieldOfForm)
        ) {
            let selectFieldDetail = props?.listTagFieldOfForm?.find(field => {
                return field.id === props?.selectedTagField?.id;
            });

            if (!Utils.isEmptyObject(selectFieldDetail)) {
                let listItem = cloneDeep(selectFieldDetail.listItem);
                listItem = listItem?.map(item => {
                    item.name = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, item.name);
                    return item;
                });
                props.setListTagItem(listItem);
            }
        }
    }, [props?.selectedTagField, props.listTagFieldOfForm]);

    const open = Boolean(anchorEl);

    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const onChangeSelectedTagField = id => {
        setAnchorEl(null);
        let selectField = props?.listTagFieldOfForm?.find(field => field.id === id);
        props.setSelectedTagField(selectField);
        handleClose();
    };

    return (
        <div className="list-public-range">
            <div className="right-select-public-range" onClick={handleClick}>
                <div className="selected-options">{props?.selectedTagField?.name}</div>
                <div>
                    <img
                        src="/assets/image/chevron-down.svg"
                        alt=""
                        className={`${anchorEl && 'rotate-chevron'} chevron-icon`}
                    />
                </div>
            </div>
            <Menu
                id="demo-positioned-menu"
                aria-labelledby="demo-positioned-button"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                transformOrigin={{ horizontal: 'left', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
                getContentAnchorEl={null}
                MenuListProps={{
                    className: 'menu-list-permision'
                }}
                PaperProps={{
                    style: {
                        marginTop: '2px',
                        minWidth: anchorEl ? anchorEl.clientWidth : '300px'
                    }
                }}
            >
                {props?.listTagFieldOfForm?.length ? (
                    props?.listTagFieldOfForm?.map(tagField => (
                        <MenuItem
                            key={`bulk-action-${tagField.id}`} 
                            selected={tagField.id === props?.selectedTagField?.id}
                            onClick={e => onChangeSelectedTagField(tagField.id)}
                        >
                            <OverFlowTooltipWithTabsMui
                                value={tagField.name}
                                onClick={e => onChangeSelectedTagField(tagField.id)}
                            />
                        </MenuItem>
                    ))
                ) : (
                    <MenuItem onClick={e => handleClose()}>
                        {'選択可能なフィールドはありません。'}
                    </MenuItem>
                )}
            </Menu>
        </div>
    );
}

export default ListTagFieldDropDown;
